import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { RecruitmentRequisition, RecruitmentRequisitionCreate, RecruitmentRequisitionFilter } from '../data/recruitmentRequisition';

export function createRecruitmentRequisitionService(client: AxiosInstance) {
  return createCrudService<RecruitmentRequisition, RecruitmentRequisitionCreate, RecruitmentRequisitionFilter>(
    client,
    '/hrm/RecruitmentRequisition',
    'id',
  );
}

export type RecruitmentRequisitionService = CrudService<RecruitmentRequisition, RecruitmentRequisitionCreate, RecruitmentRequisitionFilter>;
